module.exports = __webpack_public_path__ + "assets/img/en-ff30f503.png";